/**
 * Нативний модальний `<dialog>` (components.md, розд. 9): `showModal()` при монтуванні — фокус
 * усередині, решта сторінки інертна; `Esc` (подія `cancel`) викликає `onClose`, браузер сам діалог
 * не закриває — це робить розмонтування. jsdom на `Esc` події `cancel` не шле, тож
 * діалоги слухають `keydown` Escape ще й самі.
 */
import { type RefObject, useEffect, useRef } from 'react';

export function useModal(ref: RefObject<HTMLDialogElement | null>, onClose: () => void) {
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (!dialog.open) dialog.showModal();
    const onCancel = (e: Event) => {
      e.preventDefault();
      close.current();
    };
    dialog.addEventListener('cancel', onCancel);
    return () => {
      dialog.removeEventListener('cancel', onCancel);
      if (dialog.open) dialog.close();
    };
  }, [ref]);
}
